// External Dependencies:
import React from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Menu from 'church-theme-library/components/Menu/Menu'
import LocaleSelect from 'church-theme-library/components/LocaleSelect/LocaleSelect'
import SearchBar from 'church-theme-library/components/Search/SearchBar'

// Redux:
import { closeMenu } from 'church-theme-library/redux/actions/site'
import { openSearch, closeSearch, search } from 'church-theme-library/redux/actions/search'

class HeaderPrimary extends React.Component {
	render() {
		const { match, homeUrl, siteFullName, customLogoUrl, locale } = this.props
		let sdaLogoUrl = `${siteData.symbol_tight_base_url}night.svg`

		return (
			<header className="header">
				<div className="header-primary">
					<div className="-inner">
						<div className="-content">
							{ customLogoUrl &&
								<div className="-logo">
									<Link to={ homeUrl }>
										<div className="-image">
											<img src={ customLogoUrl } alt={ siteFullName } />
										</div>
									</Link>
								</div>
							||
								<div className="-logo">
									<Link to={ homeUrl }>
										<div className="-symbol">
											<img src={ sdaLogoUrl } alt={ siteFullName } />
										</div>

										<div className="-text" dangerouslySetInnerHTML={ { __html: siteFullName } } />
									</Link>
								</div>
							}
						</div>
					</div>
				</div>

				<div className="header-secondary">
					<div className="-inner">
						<div className="-content">
							<Menu match={ match } />

							<LocaleSelect />

							<SearchBar />
						</div>
					</div>
				</div>
			</header>
		)
	}
}

const mapStateToProps = ( state, ownProps ) => {
	return {
		homeUrl: state.site.homeUrl,
		siteFullName: state.site.siteFullName,
		customLogoUrl: state.site.customLogoUrl,
		locale: state.site.locale
	}
}

export default connect( mapStateToProps )( HeaderPrimary )
